export default __webpack_public_path__ + "assets/images/743cefdf624ac08a2c782927b1e0623e.png";